import React, { ReactNode } from 'react';
import { Card, CardContent, Box } from '@mui/material';
import { SAP_COLORS } from '../../theme/sapDesignSystem';

export interface FilterBarProps {
  /** Filter controls (e.g. Client selector, Job name, date range). */
  children: ReactNode;
  /** Optional: loading state disables action buttons when true */
  loading?: boolean;
}

/**
 * Standard filter/search area for list pages.
 * Renders a Card with consistent padding and layout.
 */
const FilterBar: React.FC<FilterBarProps> = ({ children, loading = false }) => {
  return (
    <Card
      sx={{
        mb: 3,
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        bgcolor: SAP_COLORS.sapWhite,
        border: `1px solid ${SAP_COLORS.sapGray2}`,
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            alignItems: { xs: 'stretch', md: 'center' },
            flexWrap: 'wrap',
            justifyContent: { xs: 'flex-start', md: 'space-between' },
            opacity: loading ? 0.7 : 1,
            pointerEvents: loading ? 'none' : 'auto',
          }}
        >
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterBar;
